import { validateCNPJ } from 'validations-br';

class CNPJValidatorAdapter {
  isValid (cnpjNumber) {
    return validateCNPJ(cnpjNumber);
  }
}

export default CNPJValidatorAdapter;
